import script from "./GbdflManualBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./GbdflManualBlock.vue?vue&type=script&setup=true&lang=js"

import "./GbdflManualBlock.vue?vue&type=style&index=0&id=7c6b9625&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c6b9625"]])

export default __exports__